// todo: move to using verge3d module.js
/* eslint-disable */
// need to disable linter or compile fails, need to move to module import
// todo:turn this into better syntax
let pGlob = {}

pGlob.objCache = {}
pGlob.fadeAnnotations = true
pGlob.objClickCallbacks = []
pGlob.pickedObject = ''
pGlob.objHoverCallbacks = []
pGlob.hoveredObject = ''
pGlob.objMovementInfos = {}
pGlob.objDragOverCallbacks = []
pGlob.objDragOverInfoByBlock = {}
pGlob.dragMoveOrigins = {}
pGlob.dragScaleOrigins = {}
pGlob.mediaElements = {}
pGlob.loadedFiles = {}
pGlob.loadedFile = ''
pGlob.promiseValue = ''
pGlob.animMixerCallbacks = []
pGlob.arHitPoint = new v3d.Vector3(0, 0, 0)
pGlob.states = []
pGlob.percentage = 0
pGlob.animateParamUpdate = null
pGlob.openedFile = ''
pGlob.xrSessionAcquired = false
pGlob.xrSessionCallbacks = []
pGlob.screenCoords = new v3d.Vector2()
pGlob.gamepadIndex = 0

pGlob.AXIS_X = new v3d.Vector3(1, 0, 0)
pGlob.AXIS_Y = new v3d.Vector3(0, 1, 0)
pGlob.AXIS_Z = new v3d.Vector3(0, 0, 1)
pGlob.MIN_DRAG_SCALE = 10e-4
pGlob.SET_OBJ_ROT_EPS = 1e-8

pGlob.vec2Tmp = new v3d.Vector2()
pGlob.vec2Tmp2 = new v3d.Vector2()
pGlob.vec3Tmp = new v3d.Vector3()
pGlob.vec3Tmp2 = new v3d.Vector3()
pGlob.vec3Tmp3 = new v3d.Vector3()
pGlob.vec3Tmp4 = new v3d.Vector3()
pGlob.eulerTmp = new v3d.Euler()
pGlob.eulerTmp2 = new v3d.Euler()
pGlob.quatTmp = new v3d.Quaternion()
pGlob.quatTmp2 = new v3d.Quaternion()
pGlob.colorTmp = new v3d.Color()
pGlob.mat4Tmp = new v3d.Matrix4()
pGlob.planeTmp = new v3d.Plane()
pGlob.raycasterTmp = new v3d.Raycaster()
pGlob.intervals = {}

pGlob.wooProductInfo = {}

let pPhysics = {}

pPhysics.tickCallbacks = []
pPhysics.syncList = []

// internal info
pPhysics.collisionData = []

// goes to collision callback
pPhysics.collisionInfo = {
  objectA: '',
  objectB: '',
  distance: 0,
  positionOnA: [0, 0, 0],
  positionOnB: [0, 0, 0],
  normalOnB: [0, 0, 0]
}

export { pGlob, pPhysics }
